import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';

import { Link } from '@bibliocommons/base-links';

import cardShape from 'app/shapes/cardShape';

import './ContentCardType.scss';

function ContentCardType({ card, recommendationType, cmsUrl, handleContentExplore, intl }) {
  const slug = card.getIn(['contentType', 'slug'], '');
  const defaultLabel = card.getIn(['contentType', 'label'], '');

  if ((slug === 'no-label' && !(recommendationType === 'spotlight')) || (!slug && !defaultLabel)) return null;

  const linkText = intl.formatMessage({
    id: `card_type_${slug?.replace('-', '_')}`,
    defaultMessage: defaultLabel
  });

  return (
    <div className="cp-content-card-type">
      {recommendationType === 'spotlight' && (
        <span>
          <FormattedMessage id="card_type_spotlight" /> {!(slug === 'no-label') && '| '}
        </span>
      )}
      {recommendationType === 'timely' && (
        <span>
          <FormattedMessage id="card_type_timely" /> {!(slug === 'no-label') && '| '}
        </span>
      )}
      {!(slug === 'no-label') &&
        (cmsUrl ? (
          <Link
            href={`${cmsUrl.replace(/\/+$/, '')}/explore?post-type=${slug}`}
            dataKey="content-card-type-link"
            handleClick={() => handleContentExplore(card, linkText)}
          >
            {linkText}
          </Link>
        ) : (
          <p>{linkText}</p>
        ))}
    </div>
  );
}

ContentCardType.defaultProps = {
  handleContentExplore: () => null
};

ContentCardType.propTypes = {
  card: cardShape.isRequired,
  recommendationType: PropTypes.string,
  cmsUrl: PropTypes.string,
  handleContentExplore: PropTypes.func
};

export default injectIntl(ContentCardType);
